import { TROUSER_DEFAULT_MEASUREMENTS } from '@/lib/patterns/trouser/defaults';
import { createGarmentContract } from '@/lib/patterns/contract';
import { buildTrouserBlocks } from '@/lib/patterns/trouser/blocks';
import { TROUSER_DISPLAY_OPTIONS } from '@/lib/patterns/trouser/displayOptions';
import {
  generateTrouserPatternSIyV2,
  generateTrouserPatternSIyV3,
  generateTrouserPatternSIyV4,
  TROUSER_ACTIVE_FORMULA_VERSION,
  TROUSER_V3_FORMULA_VERSION,
  TROUSER_V2_FORMULA_VERSION,
} from '@/lib/patterns/trouser/siy_v1';
import {
  TROUSER_GEOMETRY_V2,
  TROUSER_GEOMETRY_V3,
  TROUSER_GEOMETRY_V4,
  TROUSER_ACTIVE_GEOMETRY_VERSION,
  resolveTrouserGeometryVersionFromFormula,
  resolveTrouserFormulaVersionFromGeometry,
  migrateTrouserPatternForward,
} from '@/lib/patterns/trouser/version';

export { TROUSER_GEOMETRY_V2, TROUSER_GEOMETRY_V3, TROUSER_GEOMETRY_V4, TROUSER_ACTIVE_GEOMETRY_VERSION };

export {
  TROUSER_DEFAULT_MEASUREMENTS,
  TROUSER_ACTIVE_FORMULA_VERSION,
  TROUSER_V3_FORMULA_VERSION,
  TROUSER_V2_FORMULA_VERSION,
};

export { TROUSER_DISPLAY_OPTIONS };

export { resolveTrouserGeometryVersionFromFormula, resolveTrouserFormulaVersionFromGeometry, migrateTrouserPatternForward };

export function generateTrouserPattern(measurements, controls = {}) {
  const geometryVersion = controls.geometryVersion
    || resolveTrouserGeometryVersionFromFormula(controls.formulaVersion);

  const formulaVersion = resolveTrouserFormulaVersionFromGeometry(geometryVersion);

  if (geometryVersion === TROUSER_GEOMETRY_V2) {
    const generated = generateTrouserPatternSIyV2(measurements, {
      ...controls,
      formulaVersion,
      geometryVersion,
    });

    return {
      ...generated,
      formulaVersion,
      geometryVersion,
    };
  }

  if (geometryVersion === TROUSER_GEOMETRY_V3) {
    const generated = generateTrouserPatternSIyV3(measurements, {
      ...controls,
      formulaVersion,
      geometryVersion,
    });

    return {
      ...generated,
      formulaVersion,
      geometryVersion,
    };
  }

  const generated = generateTrouserPatternSIyV4(measurements, {
    ...controls,
    formulaVersion,
    geometryVersion,
  });

  return {
    ...generated,
    formulaVersion,
    geometryVersion,
  };
}

export const computeTrouser = generateTrouserPattern;

export const TROUSER_CONTRACT = createGarmentContract({
  garment: 'trouser',
  defaults: TROUSER_DEFAULT_MEASUREMENTS,
  compute: computeTrouser,
  version: TROUSER_ACTIVE_GEOMETRY_VERSION,
  supportedVersions: [TROUSER_GEOMETRY_V2, TROUSER_GEOMETRY_V3, TROUSER_GEOMETRY_V4],
  migrate: migrateTrouserPatternForward,
  blocks: buildTrouserBlocks,
  displayOptions: TROUSER_DISPLAY_OPTIONS,
});

